import React, { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import { connect, useDispatch } from 'react-redux'
import {
  getLoginAccess,
  setErrorMessage,
  setSuccessMessage,
} from './loginSlice'
import { setDefaultPage } from '../AppSlice'
import { setActiveTab, setOpenTabs, setSidebarTabs, setTabStack } from "../sidebar/sidebarSlice"
import { LOGIN_CONSTANTS } from '../../sharedfiles/Constants'
import { Button } from '../../ui/button'
import { Input } from '../../ui/input'
import { Label } from '../../ui/label'
import { Alert, AlertDescription } from '../../ui/alert'
import { Eye, EyeOff, Lock, User, AlertCircle, Loader2, Zap, BarChart2, ShieldCheck } from 'lucide-react'
import BluestuffLogo from '../Common/BluestuffLogo'
const Login = (props) => {
  const [userName, setUserName] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [usernameControl, setUsernameControl] = useState(false)
  const [passwordControl, setPasswordControl] = useState(false)
  const [errorConditon, setErrorConditon] = useState(false)
  const [successConditon, setSuccessConditon] = useState(false)
  const dispatch = useDispatch()
  const userNameHandler = (e) => {
    e.target.value.length > 0 && dispatch(setErrorMessage(''))
    e.target.value.length > 0 && setErrorConditon(false)

    setUserName(e.target.value)
    if (e.target.value.length > 0) {
      setUsernameControl(false)
    }
  }
  const passwordHandler = (e) => {

    e.target.value.length > 0 && dispatch(setErrorMessage(''))
    e.target.value.length > 0 && setErrorConditon(false)

    setPassword(e.target.value)
    if (e.target.value.length > 0) {
      setPasswordControl(false)
    }
  }

  const onSubmit = (e) => {
    e.preventDefault()
    var logindata = {
      password: password,
      userName: userName,
    }
    if (userName !== '' || password !== '') {
      dispatch(getLoginAccess(logindata, props))
    }
    if (userName === '') {
      setUsernameControl(true)
      setErrorConditon(false)
    }

    if (password === '') {
      setPasswordControl(true)
      setErrorConditon(false)
    }
  }
  useEffect(() => {
    let mounting = true
    if (mounting) {
      dispatch(setErrorMessage(''))
      dispatch(setSuccessMessage(''))
      dispatch(setDefaultPage(''))

      const validSession = localStorage.getItem('token') && localStorage.getItem('merchantId');
      if (!validSession) {
        props.cleanStore();
        dispatch(setSidebarTabs([]));
        dispatch(setOpenTabs(["MANAGEMENT REPORTING"]));
        dispatch(setTabStack([]));
        dispatch(setActiveTab("DASHBOARD"));
      }
    }
    return () => {
      mounting = false;
    }
  }, []);

  useEffect(() => {
    if (props.errorMessage !== '') {
      setPasswordControl(false)
      setUsernameControl(false)
      setErrorConditon(true)
    }
    if (password != '' && userName == '') {
      setUsernameControl(true)
      setErrorConditon(false)
    }
    if (password == '' && userName != '') {
      setPasswordControl(true)
      setErrorConditon(false)
    }
  }, [props.errorMessage])

  useEffect(() => {
    if (props.successMessage !== '') {
      setPasswordControl(false)
      setUsernameControl(false)
      setErrorConditon(false)
      setSuccessConditon(true)
    }
  }, [props.successMessage])

  return (
    <>
      <div className="h-screen overflow-y-auto flex flex-col lg:flex-row">

        {/* ── LEFT BRAND PANEL ── */}
        <div
          className="relative hidden lg:flex lg:w-1/2 flex-col items-center justify-center overflow-hidden"
          style={{ background: 'linear-gradient(145deg, #060e1d 0%, #091828 55%, #0d2040 100%)' }}
        >
          {/* Decorative blurred orbs */}
          <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full opacity-20"
            style={{ background: 'radial-gradient(circle, #3b82f6 0%, transparent 70%)' }} />
          <div className="absolute -bottom-32 -right-20 w-[28rem] h-[28rem] rounded-full opacity-10"
            style={{ background: 'radial-gradient(circle, #3b82f6 0%, transparent 70%)' }} />

          {/* Grid pattern overlay */}
          <div className="absolute inset-0 opacity-[0.04]"
            style={{
              backgroundImage: 'linear-gradient(#3b82f6 1px, transparent 1px), linear-gradient(90deg, #3b82f6 1px, transparent 1px)',
              backgroundSize: '40px 40px'
            }} />

          {/* Brand content */}
          <div className="relative z-10 flex flex-col items-center text-center px-12">
            <div className="mb-10 p-6 rounded-3xl bg-white/5 backdrop-blur-sm border border-white/10 shadow-2xl">
              <BluestuffLogo variant="dark" className="h-8 w-auto" />
            </div>

            <h2 className="text-3xl font-bold text-white mb-4 leading-tight">
              Sportsbook<br />Management Platform
            </h2>
            <p className="text-slate-400 text-base leading-relaxed max-w-xs">
              All-in-one back-office suite for monitoring, operations, and analytics — in real time.
            </p>

            {/* Feature pills */}
            <div className="mt-10 flex flex-col gap-3 w-full max-w-xs">
              {[
                { Icon: Zap, label: 'Real-time Monitoring' },
                { Icon: BarChart2, label: 'Advanced Reporting & BI' },
                { Icon: ShieldCheck, label: 'Enterprise-grade Security' },
              ].map(({ Icon, label }) => (
                <div
                  key={label}
                  className="flex items-center gap-3 px-4 py-3 rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm"
                >
                  <Icon className="h-4 w-4 text-blue-400 shrink-0" />
                  <span className="text-sm font-medium text-slate-200">{label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Bottom watermark */}
          <p className="absolute bottom-6 text-slate-600 text-xs">
            © {new Date().getFullYear()} Bluestuff. All rights reserved.
          </p>
        </div>

        {/* ── RIGHT FORM PANEL ── */}
        <div className="flex-1 flex flex-col items-center justify-center bg-gray-50 dark:bg-slate-900 p-6 sm:p-10">

          {/* Mobile-only logo */}
          <div className="flex lg:hidden mb-8 px-6 py-4 rounded-2xl">
            <BluestuffLogo className="h-9 w-auto" />
          </div>

          <div className="w-full max-w-sm">
            {/* Heading */}
            <div className="mb-8">
              <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
                {LOGIN_CONSTANTS.header_Login}
              </h1>
              <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                Enter your credentials to continue
              </p>
            </div>

            <form onSubmit={(e) => onSubmit(e)} className="space-y-5">

              {/* Username Field */}
              <div className="space-y-1.5">
                <Label htmlFor="userName" className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  {LOGIN_CONSTANTS.input_userName}
                </Label>
                <div className="relative">
                  <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                  <Input
                    id="userName"
                    type="text"
                    name="userName"
                    value={userName}
                    placeholder="Enter your username"
                    onChange={userNameHandler}
                    className={`pl-9 h-11 bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 focus-visible:ring-[#1a86f3] focus-visible:border-[#1a86f3] transition-colors ${usernameControl ? 'border-destructive focus-visible:ring-destructive' : ''}`}
                  />
                </div>
                {usernameControl && (
                  <p className="text-xs text-destructive flex items-center gap-1 mt-1">
                    <AlertCircle className="h-3 w-3" />
                    Please enter a valid username
                  </p>
                )}
              </div>

              {/* Password Field */}
              <div className="space-y-1.5">
                <Label htmlFor="password" className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  {LOGIN_CONSTANTS.input_password}
                </Label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                  <Input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    name="password"
                    placeholder="Enter your password"
                    onChange={passwordHandler}
                    className={`pl-9 pr-10 h-11 bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 focus-visible:ring-[#1a86f3] focus-visible:border-[#1a86f3] transition-colors ${passwordControl ? 'border-destructive focus-visible:ring-destructive' : ''}`}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors"
                  >
                    {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                  </button>
                </div>
                {passwordControl && (
                  <p className="text-xs text-destructive flex items-center gap-1 mt-1">
                    <AlertCircle className="h-3 w-3" />
                    Please enter a valid password
                  </p>
                )}
              </div>

              {/* Error / Success Alerts */}
              {errorConditon && props.errorMessage === 'INVALID_USER_NAME_OR_PASSWORD' && (
                <Alert variant="destructive" className="py-2.5">
                  <AlertCircle className="h-4 w-4" />
                  <AlertDescription className="text-sm">
                    Invalid username or password. Please try again.
                  </AlertDescription>
                </Alert>
              )}
              {props.errorMessage === 'Account De Activated' && (
                <Alert variant="destructive" className="py-2.5">
                  <AlertCircle className="h-4 w-4" />
                  <AlertDescription className="text-sm">
                    Your account has been deactivated. Please contact support.
                  </AlertDescription>
                </Alert>
              )}
              {successConditon && props.successMessage && (
                <Alert className="py-2.5 border-green-200 bg-green-50 text-green-800 dark:border-green-800 dark:bg-green-950 dark:text-green-200">
                  <AlertDescription className="text-sm">{props.successMessage}</AlertDescription>
                </Alert>
              )}

              {/* Login Button */}
              <Button
                type="submit"
                className="w-full h-11 text-sm font-semibold shadow-md hover:shadow-lg transition-all duration-200 mt-2"
                style={{ background: 'linear-gradient(135deg, #1a86f3 0%, #0d5bbd 100%)' }}
                size="lg"
                disabled={props.isLoading}
              >
                {props.isLoading ? (
                  <>
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    Signing in...
                  </>
                ) : (
                  LOGIN_CONSTANTS.login_btn
                )}
              </Button>
            </form>

            {/* Footer note */}
            <p className="text-center text-xs text-gray-400 dark:text-gray-500 mt-8 flex items-center justify-center gap-1.5">
              <Lock className="h-3 w-3" />
              Protected by enterprise-grade security
            </p>
          </div>
        </div>

      </div>
    </>
  )
}
function mapStateToProps(state) {
  return {
    userData: state.loginSlice.userData,
    message: state.loginSlice.message,
    successMessage: state.loginSlice.successMessage,
    errorMessage: state.loginSlice.errorMessage,
    isLoading: state.loginSlice.isLoading,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    actions: bindActionCreators({}, dispatch),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(Login)
